// extracted by mini-css-extract-plugin
export default {"inputs":"VUnMfS19","next":"WODLu2MY"};